module.exports = __webpack_public_path__ + "static/media/DeviceLookUp.94e4b33f.svg";